module.exports = __webpack_public_path__ + "img/hot-img1.d0586985.png";